import { firestore } from '../lib/db';
import { firstSetUrl, getEpisodeDataFromDocId } from './index';
import {
    saveLocally, retrieveLocally, searchString, serverApi, serverApiEurope, cdnApi, getIdFromUID, print, firestoreApi,
    cloudSearchUrl, cloudSearchHeaders, testData, elasticCloudSearchBaseApi, elasticCloudSearchHeaders, elasticSearchKey,
    elasticSearchBase, elasticSearchEngine, getDaysAgo
} from '../lib/utils';
import { getBrowsePodcastsArray, setBrowsePodcasts, getBrowseEpisodesArray, setBrowseEpisodes } from '../lib/fileUtils';
import {
    LOADING_BROWSE_PODCASTS, LOADING_BROWSE_EPISODES
}
    from './types';
import FireStoreParser from 'firestore-parser';
import fetch from 'isomorphic-unfetch';
import { Timestamp, collection, collectionGroup, query, where, getDoc, orderBy, limit, startAfter, getDocs, deleteField, doc, setDoc } from "firebase/firestore/lite";

let publicPlaylistsTrending;
export const getBrowsePlaylists = async (typeId) => {
    //   store.dispatch(ErrorBrowsePlaylistsAction({
    //     'errorBrowsePlaylists': {'error': false}
    //   }));
    if (publicPlaylistsTrending) {
        return publicPlaylistsTrending;
    }

    const promise1 = fetch(`${serverApi}getTagsTrending`).then(async (dataInit) => {
        const data = await dataInit.json();
        console.dir(data);
        const tags = data['tagResults'] || [];
        return tags;
    }).catch(err => []);

    const promise2 = getDocs(query(collection(firestore, "playlists"), where('type', '==', 'public'), where('rating', '>', 20),
        //   orderBy('pubDate', 'desc'),
        limit(30))).then((snapshot) => {
            const playlists = [];
            console.dir(snapshot);
            snapshot.docs.forEach((doc) => {
                if (doc.exists) {
                    const data = doc.data() || {};
                    data['playlistId'] = doc.id;
                    playlists.push(data);
                }
            });
            playlists.sort((el1, el2) => el2['rating'] - (el1['rating']));
            return playlists;
        }).catch(err => []);
    const results = await Promise.all([promise1, promise2]);
    const playlistsAll = [];
    results.forEach(result => {
        console.dir(result);
        playlistsAll.push(...result);
    });
    publicPlaylistsTrending = playlistsAll;
    return playlistsAll;
}

// static Future<dynamic> podcastIndexSearchPodcasts(String queryText,
//     {int limit = 10}) async {
export const podcastIndexSearchPodcasts = async (queryText, limit = 10) => {
    if (!queryText || queryText.length < 3) {
        return;
    }
    console.log('in podcastIndexSearchPodcasts');
    // AnalyticsEvents.logSearch(queryText);

    const queryString = serverApi + `searchPodcastIndexByQuery?searchTerm=${queryText}&limit=${limit}`;

    try {
        const response = await fetch(encodeURI(queryString));
        // print('podcastIndexSearchPodcasts100');
        // print(response);
        const json = await response.json(); // jsonDecode(response.data);
        return json;
    } catch (e) {
        console.error(e);
        return [];
    }
}

// static Future < dynamic > podcastIndexSearchEpisodes(String queryText,
//     { int limit = 10 }) async {
export const podcastIndexSearchEpisodes = async (queryText, limit = 10) => {
    if (!queryText || queryText.length < 3) {
        return;
    }
    console.log('in podcastIndexSearchEpisodes');
    // AnalyticsEvents.logSearch(queryText);

    const queryString = serverApi + `searchPodcastIndexByPeople?searchTerm=${queryText}&limit=${limit}`;

    try {
        const response = await fetch(encodeURI(queryString));
        // print('podcastIndexSearchPodcasts100');
        // print(response);
        var json = await response.json(); // jsonDecode(response.data);
        return json;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export const searchAllEpisodes = async (queryText, limit = 2, minDays = 0) => {
    console.dir('in itunesSearchEpisodes');

    const searchText = queryText;
    // const limit = req.query.limit || 2;
    if (!searchText || searchText.length < 3) {
        return {};
    }
    if (minDays == 0) {
        const prevResults = JSON.parse(retrieveLocally(searchString(queryText, limit)));
        console.dir(prevResults);
        if (prevResults) {
            return prevResults;
        }
    }

    /// cloud Search
    const queryString = elasticCloudSearchBaseApi + `/search?query=${queryText}`; // cloudSearchUrl(queryText, limit);
    console.dir(queryString);
    try {
        const body = {
            'search_fields': {
                'title': {},
                // 'title': { 'weight': 10 },
                // 'collection_name': {'weight': 3},
                // 'genres': { 'weight': 1 },
            },
            'page': { 'size': limit, 'current': 1 }
        };
        console.dir(minDays);
        if (minDays > 0) {
            body['filters'] = {
                "pub_date": {
                    "from": getDaysAgo(minDays),
                }
            }
            // body['sort'] = {
            //     'pub_date': 'desc'
            // }
        }
        console.dir(body);
        let response = await fetch(queryString, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: elasticCloudSearchHeaders,
            body: JSON.stringify(body)
        })
        const json = await response.json();
        // const json = {"results": [
        //     {
        //         "title": {
        //             "raw": "Conan O'Brien"
        //         },
        //         "genres": {
        //             "raw": [
        //                 "Books",
        //                 "Arts",
        //                 "TV & Film"
        //             ]
        //         },
        //         "artwork_url_600": {
        //             "raw": "https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/76/32/0c/76320cb7-7805-5ffc-6d48-18b311dd9be8/mza_18321298089187816075.jpg/600x600bb.jpg"
        //         },
        //         "_meta": {
        //             "id": "b1b97221-8d7a-4de1-a501-d06abb8ae96b",
        //             "engine": "episodes",
        //             "score": 13.770508
        //         },
        //         "id": {
        //             "raw": "b1b97221-8d7a-4de1-a501-d06abb8ae96b"
        //         },
        //         "pub_date": {
        //             "raw": 1.606426252E12
        //         },
        //         "duration_in_sec": {
        //             "raw": 2992.0
        //         }
        //     }]};
        const resultsArrayInit = json['results'];
        console.dir(resultsArrayInit);
        const resultsArray = resultsArrayInit.filter(el => el._meta.score > (minDays > 0 ? 10 : 1));
        if (minDays > 0) {
            resultsArray.sort((el1, el2) => el2['pub_date']['raw'] - el1['pub_date']['raw']);
        }
        console.dir(resultsArray);
        const resultsArrayFin = [];
        for (const result of resultsArray) {
            const resultFin = {
                'guid': result['id']['raw'],
                'title': result['title']['raw'],
                'genres': result['genres']['raw'],
                'artworkUrl600': result['artwork_url_600']['raw'],
                // 'collectionName': result['collection_name']['raw'],
                'pubDate': (result['pub_date']['raw']),
                'enclosure': { 'duration': result['duration_in_sec']['raw'] },
            };
            resultsArrayFin.push(resultFin);
        }
        // console.dir('resultsArray : ');
        console.dir(resultsArrayFin);
        saveLocally(searchString(queryText, limit), JSON.stringify(resultsArrayFin), 24 * 5);
        return resultsArrayFin;
    } catch (err) {
        // throw err;
        return [];
    }
}



export const searchAllEpisodesFirestore = async (
    queryText,
    limit = 2) => {
    print('in itunesSearchEpisodes');
    print(limit);
    let searchText = queryText;
    // const limit = req.query.limit || 2;
    print(searchText);
    if (searchText == null || searchText.length < 3) {
        return [];
    }
    // final response =
    //     await readFileWithModifiedTime(utils.searchString(queryText, limit));
    const prevResults = JSON.parse(retrieveLocally(searchString(queryText, limit)));
    console.dir(prevResults);
    if (prevResults) {
        return prevResults;
    }

    let cloudSearchResults =
        await searchAllEpisodes(queryText, limit);
    let docIds = [];
    let futures = [];
    for (let cloudSearchResult of cloudSearchResults) {
        docIds.push(cloudSearchResult['guid']);
        futures.push(getEpisodeDataFromDocId(cloudSearchResult['guid']));
    }
    console.log('docIds : ' + docIds);
    let episodes = await Promise.all(futures);
    // print('episodes : ' + episodes.toString());
    if (episodes && episodes.length > 0) {
        // final List < Map > rawEpisodes =[];
        // for (PodcastEpisode episode in episodes) {
        //     rawEpisodes.add(episode.toJson());
        // }
        // save(utils.searchString(queryText, limit), rawEpisodes);
        saveLocally(searchString(queryText, limit), JSON.stringify(episodes), 24 * 5);
    }
    return episodes;
}


// Future<List> getPopularSearches(String genre) async {
export const getPopularSearches = async (genre) => {
    try {
        const res =
            await fetch(`${firestoreApi}trending-searches/${genre}`);
        const result = await res.json();
        console.dir(result);
        if (result) {
            const parsedResult = FireStoreParser(result);
            console.dir(parsedResult);
            if (parsedResult.fields) {
                const data = parsedResult['fields'];
                const searches = data['searches'] || {};
                // print('searches1 : ' + searches.toString());
                console.dir(searches);
                const searchesList = Object.values(searches);
                console.dir(searchesList);
                searchesList.sort((s1, s2) => (s1['index'] || 0) < (s2['index'] || 0));
                return searchesList;
            }
        }
        return [];
    } catch (err) {
        print(err);
        return [];
    }
}